$(document).on('change', '.noardcode-media-library-panel-input .custom-file-input', (e) => {
    let fN = '';
    for (const fK in e.target.files) {
        if(e.target.files.hasOwnProperty(fK)) {
            fN += ((fN !== '' ? ', ' : '') + e.target.files[fK].name)
        }
    }
    $(e.target).siblings('label').text(fN.length > 0 ? fN : 'File selected')
});
